import { Label } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './Labels.css';
import { getBackgroundColor, getTextColor } from './utils';
import { EColor, IPhotoLabel } from '../../../../../common/repositories/dailyrent/entities/photo_label/PhotoLabel';
import { ILabelTooltip, LabelTooltip } from '../LabelTooltip';

interface IProps {
  labels: IPhotoLabel[];
  className?: string;
}

const TOOLTIP_MAP: Partial<Record<EColor, ILabelTooltip>> = {
  blueVerifiedByCian: {
    description:
      'Убедились, что информация в объявлении верна — оценили видео, фото объекта или дополнительно проанализировали объявление',
    link: 'https://support.cian.ru/ru/knowledge_base/article/7516/category/463',
    linkText: 'Подробнее',
  },
  blueInstantBooking: {
    description: 'Это жильё можно забронировать без переговоров с владельцем и долгого ожидания подтверждения брони',
  },
};

export const Labels = ({ labels, className }: IProps) => {
  const key = React.useId();
  // Временно скрываем лейбл "только на циан" на фронте пока не сделана задача CD-179745
  const filteredLabels = labels.filter(({ color }) => color !== EColor.BlueOnlyCian);

  const handleClick = React.useCallback((e: React.MouseEvent) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
  }, []);

  if (!filteredLabels.length) {
    return null;
  }

  return (
    <div className={cn(styles['container'], className)}>
      {filteredLabels.map(({ name, color }) => {
        return (
          <LabelTooltip key={`label_${key}_${color}`} tooltip={TOOLTIP_MAP[color]}>
            <Label onClick={handleClick} background={getBackgroundColor(color)} color={getTextColor(color)}>
              {name}
            </Label>
          </LabelTooltip>
        );
      })}
    </div>
  );
};
